import React from "react";
import styled from "@emotion/styled";
import { connect } from "react-redux";
import { Link } from "gatsby";
import {
  getMissions,
  getBraceletColor,
  getBraceletName,
  getHasClaimedBonus,
} from "modules/playground/selectors";
import { loadMissions, claimBonus } from "modules/playground/action";
import MissionProgress from "components/MissionProgress";
import Loading from "components/Loading";

const MissionPageLayout = styled.div`
  padding: 32px;
`;

const MissionHeader = styled.h3`
  font-size: 32px;
  font-family: "Gilroy";
  text-align: center;
  margin: 0;
`;

const MissionProgressLayout = styled.div`
  margin: 16px auto;
`;

const MissionDesc = styled.div`
  text-align: center;
  margin: 16px auto;
`;

const MissionList = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  margin: 16px auto;

  input[type="checkbox"]:checked ~ span {
    background-color: ${props => props.color};
    border-color: ${props => props.color};
  }
`;

const MissionButton = styled.button`
  background: ${props => props.bgColor};
  font-weight: bold;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  margin: 16px auto;
  border: none;
  display: block;
  color: ${props => props.color};
`;

const LoadingLayout = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
`;

const renderMissions = missions =>
  missions.map(mission => (
    <label key={mission.name} className="for-input">
      {mission.name}
      <input type="checkbox" disabled checked={mission.is_done} />
      <span />
    </label>
  ));

function MissionPage({
  missions,
  braceletColor,
  braceletName,
  hasClaimedBonus,
  claimBonus,
}) {
  if (missions === null || braceletColor === undefined) {
    return (
      <LoadingLayout>
        <Loading />
      </LoadingLayout>
    );
  }

  const completedMissions = missions.filter(missions => missions.is_done);
  const isComplete = missions.length === completedMissions.length;

  return (
    <MissionPageLayout>
      <MissionHeader>COLOR MISSION</MissionHeader>
      <MissionProgressLayout>
        <MissionProgress
          isPage={true}
          missions={missions.length}
          completedMissions={completedMissions.length}
          braceletColor={braceletColor}
          braceletName={braceletName}
        />
      </MissionProgressLayout>
      <MissionDesc>
        {hasClaimedBonus
          ? "You have completed all of your missions. Good Job!"
          : "Get additional 1500 points by visiting all the booths according to the color of your bracelet!"}
      </MissionDesc>
      <MissionList color={braceletColor}>
        {renderMissions(missions)}
      </MissionList>
      {isComplete && (
        <MissionButton
          color={braceletColor}
          onClick={async () => {
            await claimBonus();
            loadMissions();
          }}
          bgColor={braceletColor}
          color="white"
          disabled={hasClaimedBonus}
        >
          {hasClaimedBonus ? "Bonus Claimed" : "Claim Bonus Point"}
        </MissionButton>
      )}
      <Link to="/play">
        <MissionButton bgColor="white" color="black">
          Return to Dashboard
        </MissionButton>
      </Link>
    </MissionPageLayout>
  );
}

const withConnect = connect(
  state => ({
    missions: getMissions(state),
    braceletColor: getBraceletColor(state),
    braceletName: getBraceletName(state),
    hasClaimedBonus: getHasClaimedBonus(state),
  }),
  { loadMissions, claimBonus }
);

export default withConnect(MissionPage);
